export const FLIGHT_TRACKING_RESULTS_PATH = '/flights/tracking/results'

export const FLIGHT_STATUS_CONSTANTS = {
  PAGE: {
    TITLE: 'Flight Status - Track Live Flights',
    META_DESCRIPTION: 'Track live flight status, departures and arrivals.',
    HEADING: 'Track any flight',
  },
  ERROR: {
    MISSING_PARAMETERS: 'Required search parameters are missing.',
    FETCH_FAILED: 'Unable to fetch flight status. Please try again.',
    NO_FLIGHTS: 'No flights found for your search.',
    SERVER_ERROR: 'Something went wrong. Please try again later.',
    ERROR_PAGE_TITLE: 'Something went wrong',
    GO_BACK: 'Go back',
  },
  EMPTY: {
    NO_FLIGHTS_TITLE: 'No flights found',
    NO_FLIGHTS_FLIGHT_NUMBER_LINE1: 'Please check the flight number',
    NO_FLIGHTS_FLIGHT_NUMBER_LINE2: 'and try again',
    NO_FLIGHTS_GENERIC:
      "We couldn't find any flights for your search. Try editing your search or go back.",
    NO_MATCH_FILTERS: 'No flights match your filters.',
    GO_BACK: 'Go back',
    CLEAR_FILTERS: 'Clear filters',
  },
  LABELS: {
    DEPARTURES: 'Departures',
    ARRIVALS: 'Arrivals',
    FLIGHT_TIME: 'Flight time',
    ALL_AIRLINES: 'All airlines',
    APPLY: 'Apply',
    CLEAR: 'Clear',
    AIRLINES: 'Airlines',
    TIMINGS: 'Timings',
    TAKE_OFF_FROM: 'TAKE-OFF FROM',
    LANDING_IN: 'LANDING IN',
  },
}

export const TIME_BUCKET_OPTIONS: Record<string, { label: string; time: string }> = {
  '0000': { label: 'Early morning', time: '12 AM-8 AM' },
  '0800': { label: 'Morning', time: '8 AM-12 PM' },
  '1200': { label: 'Afternoon', time: '12 PM-4 PM' },
  '1600': { label: 'Evening', time: '4 PM-8 PM' },
  '2000': { label: 'Night', time: '8 PM-12 AM' },
}

export const TIME_BUCKET_RANGES: Record<string, { start: number; end: number }> = {
  '0000': { start: 0, end: 800 },
  '0800': { start: 800, end: 1200 },
  '1200': { start: 1200, end: 1600 },
  '1600': { start: 1600, end: 2000 },
  '2000': { start: 2000, end: 2400 },
}
